module.exports = __webpack_public_path__ + "img/sbl0016.76ba957f.png";